<template>
  <a :href="url" :class="`lg:gap-x-6 lg:py-0 ${smallCard ? 'flex gap-x-3' : 'py-5 block lg:flex'} ${filterCard ? 'group' : ''}`">
    <img v-if="image" :src="!lazyLoadImage ? image : null" :data-src="lazyLoadImage ? image : null"
      :class="`flex-none lg:block max-w-[280px] object-cover ${ smallCard ? 'h-[78px] w-[138px]' : 'hidden h-[115px] w-[205px]'} 
        ${ lazyLoadImage ? 'lazyload' : '' }`" 
      :alt="cardTitle"
    >
    
    <div v-else :class="`flex-none lg:grid lg:place-items-center bg-${theme}
      ${ smallCard ? 'grid place-items-center h-[78px] w-[138px]' : 'hidden h-[115px] w-[205px]' }`"
    >
      <img :src="!lazyLoadImage ? image : null" :data-src="lazyLoadImage ? image : null" 
        :class="`max-w-[75px] w-5/12 ${ lazyLoadImage ? 'lazyload' : '' }`" 
        alt=""
      >
    </div>

    <div :class="`relative w-full ${ filterCard ? `group-hover:before:opacity-100 group-hover:after:opacity-100 before:opacity-0 after:opacity-0 
      before:bg-turquoise before:top-2 before:-left-11 before:absolute before:-z-1 before:w-16 before:h-full lg:before:w-11
      after:-z-1 after:bg-turquoise after:absolute after:w-full after:h-full after:-right-5 after:top-2 lg:after:right-0
      before:transition before:duration-300 after:transition after:duration-300` : ''}`"
    >
      <p v-if="tag" :class="`text-white uppercase w-fit text-[9px] py-1 px-2 bg-${theme} 
        ${filterCard ? 'group-hover:bg-grey transition duration-300' : '' }`"
      >
        {{ tag }}
      </p>

      <h5 :class="`font-crimson lg:mt-1 text-${theme} ${ tag && !smallCard ? 'mt-4' : '' }
        ${ smallCard ? 'text-xl leading-6 mt-1' : 'text-2xl leading-[30px]' }
        ${ filterCard ? 'group-hover:text-white transition duration-300' : '' }`"
      >
        {{ cardTitle|truncate(30) }}
      </h5>

      <p v-if="previewText" :class="`text-grey font-crimson mt-1 lg:mt-0 
        ${ smallCard ? 'text-sm leading-[18px]' : 'text-lg leading-[25px]' } 
        ${ filterCard ? 'group-hover:text-white transition duration-300' : '' }`"
      >
        {{ previewText|striptags|truncate(55) }}
      </p>
    </div>
  </a>
</template>

<script>
import Vue from 'vue';

Vue.filter('striptags', (value) => {
  return value ? value.replace(/<(?:.|\n)*?>/gm, '') : '';
})

Vue.filter('truncate', (value, length = 30, clamp = '...') => {
  return value.length <= length ? value : value.substr(0, length) + clamp;
});

export default {
  name: "MiniCard",
  props: {
    cardTitle: {
      type: String,
      required: true
    },
    tag: {
      type: String,
    },
    image: {
      type: String,
    },
    previewText: {
      type: String,
    },
    url: {
      type: String,
    },
    theme: {
      type: String,
      default: "purple"
    },
    placeHolderImage: {
      type: String,
      default: `/assets/images/logos/bury--white.svg`
    },
    filterCard: {
      type: Boolean,
      default: false,
    },
    smallCard: {
      type: Boolean,
      default: false,
    },
    lazyLoadImage: {
      type: Boolean,
      default: true,
    },
  },
}
</script>